import { useEffect, useState } from "react";
import styles from "./styles.module.css";
export default function JustifyContent({ value, onChange }) {
  const [_value, _setValue] = useState("");

  useEffect(() => {
    _setValue(value);
  }, [value]);

  const handleSelect = (value) => {
    _setValue(value);
    onChange(value);
  };

  return (
    <div style={{ display: "flex" }}>
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="start"
        value="flex-start"
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="center"
        value="center"
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="end"
        value="flex-end"
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="even"
        value="space-evenly"
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="apart"
        value="space-between"
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="around"
        value="space-around"
      />
    </div>
  );
}

const SelectButton = ({ text, value, selected, setSelected }) => {
  return (
    <div
      className={
        value === selected
          ? `${styles.selectButton} ${styles.selected}`
          : styles.selectButton
      }
      onClick={() => setSelected(value)}
    >
      {text}
    </div>
  );
};
